import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ShopPage from "./pages/ShopPage";
import ContactPage from "./pages/ContactPage";
import FlyerPage from "./pages/FlyerPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Layout wrapper that conditionally shows navbar/footer
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isFlyer = pathname === '/flyer';

  return (
    <>
      {!isFlyer && <Navbar />}
      {children}
      {!isFlyer && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/flyer" element={<FlyerPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
